<template>
  <div>
    <v-card outlined class="white box-height-100 py-6 px-2" :elevation="5">
      <div class="title-time-serie">{{ title }}</div>
      <v-simple-table fixed-header height="100%">
        <template v-slot:default>
          <thead>
            <tr>
              <th width="100" class="text-center">No</th>
              <th class="text-left">
                Word
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in words" :key="index">
              <td width="100" class="text-center">{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>
<script>
import _ from 'lodash'

import apiRealtime from '@/apis/realtime'

export default {
  props: {
    refresh: Boolean,
    from: String,
    to: String
  },
  data() {
    return {
      title: 'Popular words in last 30 mins',
      words: [],
      maxBy: { name: '', value: 0 },
      maxValue: 0,
      color: ['#555555', '#555555', '#555555', '#555555']
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler(val) {
        if (val) this.getTagCloud()
      }
    }
  },
  methods: {
    async getTagCloud() {
      try {
        const data = await apiRealtime.getTagCloud()

        this.words = []
        if (data.data.length > 0) {
          this.words = _.orderBy(data.data, ['value'], ['desc'])
        }

        if (this.words.length > 10) this.words = this.words.splice(0, 10)

        this.$emit('reset', 'tagCloud')
      } catch (error) {}
    },
    getColor(weight) {
      return weight > this.maxValue * 0.75
        ? this.color[0]
        : weight > this.maxValue * 0.5
        ? this.color[1]
        : weight > this.maxValue * 0.25
        ? this.color[2]
        : this.color[3]
    },
    getRotation() {
      const deg = [45, 315]
      return _.head(_.shuffle(deg))
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-data-table {
  height: calc(100% - 25px);
}
</style>
